import React from "react";
import AppListHome from "../../components/ui/AppListHome";
import AppListHomeSkeleton from "../../components/ui/AppListHomeSkeleton";
import BottomNavigation from "../../components/ui/BottomNavigation";
import Header from "../../components/ui/Header";
import { useHome } from "../../hooks/useHome";
 
const HomePage: React.FC = () => {
  const { dashboardQuery } = useHome();
  const { data, isLoading } = dashboardQuery;
  
  return (
    <div>
      <Header />

      <div className="section-movies ">
        {isLoading ? (
          <AppListHomeSkeleton />
        ) : (
          <AppListHome data={data?.data?.modules || []} />
        )}
        {/* {data?.data?.modules && <AppListHome data={data.data.modules} />} */}
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation />
    </div>
  );
};

export default HomePage;
